export default __webpack_public_path__ + "static/media/wip.20d0761a.png";